import * as types from "../../mutation-types";

export default {
    [types.TOGGLE_SIDEBAR] (state) {
        state.sidebar_opened = !state.sidebar_opened
    },

    [types.CLOSE_SIDEBAR] (state) {
        state.sidebar_opened = false
    }
}